import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getEventType = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `event-type`);
};

export const AddEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-type/create`,
    obj,
    { headers }
  );
};

export const EditEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-type/update`,
    obj,
    { headers }
  );
};

export const DeleteEventType = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `event-type/delete`,
    obj,
    { headers }
  );
};
